var _style, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4SigmaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 333.46 328.55",
    style: {
      enableBackground: "new 0 0 333.46 328.55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.131;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.56,307.08H78.9c-30.37,0-54.98-24.61-54.98-54.98V76.45c0-30.37,24.61-54.98,54.98-54.98h175.66 c30.37,0,54.98,24.61,54.98,54.98V252.1C309.54,282.47,284.93,307.08,254.56,307.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.0152,
    y1: 2017.6124,
    x2: 208.0706,
    y2: 2017.6124,
    gradientTransform: "matrix(1 0 0 -1 0 2181.8896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0297,
    style: {
      stopColor: "#6CBF61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#07AEB7"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "217.16,73.08 154.45,73.08 122.89,73.08 83.25,73.08 142.02,164.29 83.25,255.47 122.89,255.47  154.45,255.47 217.16,255.47 250.21,255.47 250.21,230.11 250.21,191.99 230.37,230.11 170.79,230.11 213.2,164.29 170.79,98.44  230.37,98.44 250.21,136.56 250.21,98.44 250.21,73.08  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4SigmaLogo);
export default __webpack_public_path__ + "static/media/4 sigma_logo.12a9d2baf8ee38b903bf1f830d06a639.svg";
export { ForwardRef as ReactComponent };